export default (({ req: { user } })=>Boolean(user));

//# sourceMappingURL=defaultAccess.js.map